<template>
  <div>
    <v-img
      :aspect-ratio="16 / 9"
      height="450"
      :src="require('@/assets/images/news/otamerica_esg_report_2024.jpg')"
    ></v-img>
    <!-- 
      src="@/assets/images/terminals/Oiltanking_Belgium_Antwerp_Gas_Terminal_NV_Image_tanks1_1920px.jpg"
     -->

    <v-container class="text-justify">
      <h1>{{ $t("esg2024News.title") }}</h1>
      <p v-html="$t('esg2024News.p1')"></p>
      <p v-html="$t('esg2024News.p2')"></p>
      <p v-html="$t('esg2024News.p3')"></p>
      <p v-html="$t('esg2024News.p4')"></p>
      <p v-html="$t('esg2024News.p5')"></p>
      <p v-html="$t('esg2024News.p6')"></p>
      <!--<a
        href="/otamerica-ws/controllers/fileDownload.php?name=otamerica_sustainability-report-2024.pdf"
        target="_blank"
      >
        {{ $t("esg2024News.link") }}
      </a>-->
      <div v-if="$i18n.locale === 'es'">
        <a
          href="/otamerica-ws/controllers/fileDownload.php?name=otamerica_reporte-sustentabilidad-2024.pdf"
          target="_blank"
        >
          {{ $t("esg2024News.link") }}
        </a>
      </div>
      <div v-else>
        <a
          href="/otamerica-ws/controllers/fileDownload.php?name=otamerica_sustainability-report-2024.pdf"
          target="_blank"
        >
          {{ $t("esg2024News.link") }}
        </a>
      </div>
    </v-container>
  </div>
</template>
